<template>
  <div
    class="w-full h-full hover:shadow-xl shadow-md duration-500  border-grey-400 overflow-hidden rounded-sm bg-white group cursor-pointer flex flex-col items-center">
    <img :src="items?.image" class="lg:max-h-[300px] max-h-[250px] duration-500 w-full group-hover:scale-110" alt="image"
      width="" height="" />
    <div class="p-4">
      <div class="font-sans">
        <h2 class="py-3 text-2xl font-primary font-semibold group-hover:cursor-pointer group-hover:text-primary"
          @click="handleRoute(items.slug)">{{
            items.title }}</h2>
        <p class="text-base text-grey ">{{ items?.about_service?.description.slice(0, 100) }}...</p>
      </div>
      <div class="grid grid-cols-12 bg-[#E8ECF6]  rounded-sm my-4">
        <div
          class="col-span-2 bg-primary duration-500 group-hover:bg-secondary flex justify-center items-center p-3 rounded-sm w-[65px] h-[65px]">
          <img :src="items?.svg_icon" class="object-fill text-white" alt="svg" width="" height="" />
        </div>
        <div
          class="flex justify-end col-span-10 px-2 items-center hover:cursor-pointer hover:bg-[#D7DBE3] relative bottom-0"
          @click="handleRoute(items.slug)">
          <span class="font-semibold font-primary">Service Details </span>
          <div class="bg-primary text-white rounded-full overflow-hidden ml-5 p-2">
            <img src="../../assets/v-1.1/right-arrow.svg" class="text-white" width="20" height="20" alt="img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
defineProps({
  items: Object,
});

const handleRoute = (slug) => {
  let name = slug.replaceAll(" ", "-").toLowerCase();
  router.push({ name: "service-detail", params: { name: name } });
};
</script>